import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import InfoIcon from "./InfoIcon";
import RequiredIcon from "./RequiredIcon";

interface IProps {
    controlId: string;
    id?: string;
    label?: string;
    prepend?: JSX.Element;
    append?: JSX.Element;
    className?: string;
    name: string;
    value: string;
    required: boolean;
    infoCode?: string;
    onFocusHandler?: (name: string, value: any) => void;
    onChangeHandler?: (name: string, value: any) => void;
    onBlurHandler?: (name: string, value: any) => void;
    isInvalid: boolean;
    error?: string;
    optionEmpty: boolean;
    options: JSX.Element[];
    disabled?: boolean;
    hoverTitle?: string;
    floatingLabel?: boolean;
    fullWidth?: boolean;
}

class BaseSelect extends React.Component<IProps> {
    private onFocusHandler = (evt: React.FocusEvent<HTMLSelectElement>) => {
        let value = evt.currentTarget.value;

        if (this.props.onFocusHandler != null) {
            this.props.onFocusHandler(this.props.name, value);
        }
    };

    private onChangeHandler = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        let value = evt.currentTarget.value;

        if (this.props.onChangeHandler != null) {
            this.props.onChangeHandler(this.props.name, value);
        }
    };

    private onBlurHandler = (evt: React.FocusEvent<HTMLSelectElement>) => {
        let value = evt.currentTarget.value;

        if (this.props.onBlurHandler != null) {
            this.props.onBlurHandler(this.props.name, value);
        }
    };

    public render(): JSX.Element {
        const {
            controlId,
            id,
            label,
            prepend,
            append,
            className,
            name,
            value,
            options,
            optionEmpty,
            required,
            infoCode,
            isInvalid,
            error,
            disabled,
            hoverTitle,
            floatingLabel,
            fullWidth,
        } = this.props;

        const floated = value.length > 0;

        return (
            <Form.Group
                className={floatingLabel ? "floating-label-select-form-group mb-0" : fullWidth ? "mb-0 w-100" : "mb-0"}
                controlId={controlId}
            >
                {floatingLabel === false && label ? (
                    <Form.Label>
                        {label}
                        {required ? <RequiredIcon /> : null}
                        {infoCode ? <InfoIcon label={label} code={infoCode} /> : null}
                    </Form.Label>
                ) : null}
                <InputGroup
                    className={[
                        "rounded ccq-shadow",
                        floatingLabel !== false ? "floating-label-container" : "",
                        floated ? "floated" : "",
                    ].join(" ")}
                >
                    {prepend ? (
                        <InputGroup.Prepend>
                            <InputGroup.Text className={["rounded-left", disabled ? "" : "bg-white"].join(" ")}>
                                {prepend}
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                    ) : null}
                    <Form.Control
                        as="select"
                        id={id}
                        className={[
                            prepend == null ? "rounded-left" : "",
                            append == null ? "rounded-right" : "",
                            className ? `${className} select` : "select",
                        ].join(" ")}
                        name={name}
                        value={value}
                        onFocus={this.onFocusHandler}
                        onChange={this.onChangeHandler}
                        onBlur={this.onBlurHandler}
                        isInvalid={isInvalid}
                        disabled={disabled}
                        title={hoverTitle}
                        placeholder="Selezionare..."
                        defaultValue="Selezionare..."
                    >
                        {optionEmpty ? (
                            <option hidden key="-1" value="Selezionare...">
                                {"Selezionare..."}
                            </option>
                        ) : null}
                        {options}
                    </Form.Control>
                    {floatingLabel !== false && label ? (
                        <Form.Label className="select-label">
                            {label}
                            {required ? <RequiredIcon /> : null}
                            {infoCode ? <InfoIcon label={label} code={infoCode} /> : null}
                        </Form.Label>
                    ) : null}
                    {append ? (
                        <InputGroup.Append>
                            <InputGroup.Text className={["rounded-right", disabled ? "" : "bg-white"].join(" ")}>
                                {append}
                            </InputGroup.Text>
                        </InputGroup.Append>
                    ) : null}
                </InputGroup>
                <Form.Control.Feedback type="invalid" className="d-block bg-transparent mt-1">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export { BaseSelect as Unconnected };
export default BaseSelect;
